export const isRateLimited = (rateLimitExpiryDate: Date | null) => {
  const currentDate = new Date();
  if (rateLimitExpiryDate) {
    return currentDate < rateLimitExpiryDate;
  }

  return false;
};
